export enum SortingType {
	ASCENDING = 'asc',
	DESCENDING = 'desc',
	UNDEFINED = '',
}
